
import { React, useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { ScatterChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import {
  getDate,
  getTime,
  getDay,
  formatYaxisNumber,
} from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

function Fault(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  var xAxisData = [];
  var yAxisdData = [];
  if (props.loading === "true") {
    xAxisData = [];
    yAxisdData = [];
  } else if (props.dataVal != undefined && props.loading === "false") {
    props.dataVal.map(function (obj) {
      if (props.selectValue === "HOUR_24" || props.selectValue === "HOUR_12") {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }
      yAxisdData.push(obj.faultCount);
    });
  }

  // const name=props.name
  echarts.registerTheme("my_theme", {
    backgroundColor: "#f4cccc",
  });

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    ScatterChart,
    CanvasRenderer,
  ]);

  const options = () => ({
    tooltip: {
      trigger: "item",
    },
    title: {
      // text: 'Site Status',
    },
    legend: {
      show: false,
    },
    grid: {
      left: "13%",
      right: "8%",
      bottom: "3%",
      top: 50,
      containLabel: true,
      show: true,
    },

    xAxis: {
      type: "category",
      axisTick: {
        show: false,
      },
      axisLabel: {
        rotate:
          props.selectValue === "WEEK_2" ||
          props.selectValue === "MONTH" ||
          props.selectValue === "MONTH_3"
            ? 30
            : 0,
      },
      show: true,
      splitLine: { show: true },
      data: xAxisData,
    },
    yAxis: {
      type: "value",
      name: "Number of Swap",
      nameLocation: "middle",
      nameGap: yAxisdData.every((element) => element === null) ? 10 : 32,
      splitLine: { show: true },
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
      axisLabel: {
        formatter: formatYaxisNumber,
      },
      // scale: true,

      // nameRotate: 0,
    },
    series: [
      {
        data: yAxisdData,
        type: "line",
        symbol: "circle",
        symbolSize: 10,
        smooth: false,
        itemStyle: {
          normal: {
            color: "red",
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .12)",
            // shadowOffsetX: 2,
            // shadowOffsetY: 2
          },
        },
      },
    ],
  });
  return (
    <ReactECharts
      styles={{ with: "100%", height: "80%" }}
      echarts={echarts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      opts={{ renderer: "canvas" }}
      option={options()}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
    />
  );
}
export default Fault;
